import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import getFormatPrice from '@functions/getFormatPrice.ts';
import getFormatedDate from '@functions/getFormatedDate.ts';
import { setCursorSupport } from '@functions/supportHandler.ts';
import KuperShiftItemT from '@global/models/KuperShiftItem.ts';

import { RenderColsT } from '../../types.ts';

const renderKuperShiftsItems: RenderColsT<'kuperShiftsItems'> = function ({ name: colName, item }) {
    const kuperShiftItem = item as KuperShiftItemT;
    let content;
    let className;

    if (colName === 'time') {
        content = (
            <>
                <div className="v2table__text">{kuperShiftItem.time} ч</div>
            </>
        );
    }

    if (colName === 'count') {
        content = (
            <>
                <div className="v2table__text">{kuperShiftItem.count}</div>
            </>
        );
    }

    if (colName === 'amount') {
        const dublicatesSupportProps = setCursorSupport(
            {
                _id: `dublicates-${kuperShiftItem._id}`,
                content: 'Есть дубликаты',
                dir: 'top',
            },
            { targetClassName: '.v2table__textAlert', className: '' },
        );

        const renderDublicate = () =>
            kuperShiftItem.dublicate && (
                <div className="v2table__textAlert" {...dublicatesSupportProps}>
                    <Icon name="alert" />
                </div>
            );

        content = (
            <>
                <div className="v2table__text _selectAll">
                    {getFormatPrice(kuperShiftItem.amount)} ₽
                </div>{' '}
                {renderDublicate()}
            </>
        );
    }

    if (colName === 'type') {
        const typeClassNames = {
            shift: '_successColor',
            hold: '_errorColor',
            bonus: '_processColor',
        };
        const typeClassName = typeClassNames[kuperShiftItem.shiftType];

        content = (
            <>
                <div className={`v2table__text _block _mediumWeight ${typeClassName}`}>
                    {kuperShiftItem.shiftTypeText}
                </div>
            </>
        );
    }

    if (colName === 'comment') {
        content = (
            <>
                <div className="v2table__text">{kuperShiftItem.comment || '–'}</div>
            </>
        );
    }

    if (colName === 'date') {
        content = (
            <>
                <div className="v2table__text">
                    {kuperShiftItem.date
                        ? getFormatedDate({ date: new Date(kuperShiftItem.date) })
                        : '–'}
                </div>
            </>
        );
    }

    return { content, className };
};

export default renderKuperShiftsItems;
